<template>
  <div class="search-section">
    <div class="search-container">
      <el-input v-model="searchKeyword" placeholder="请输入商品名称" size="small" class="search-input" @keyup.enter.native="handleSearch">
        <el-button slot="append" type="primary" class="search-btn" @click="handleSearch">搜索</el-button>
      </el-input>
    </div>
    <div class="quick-search" v-if="showQuickSearch">
      <span class="quick-search-title">热门搜索：</span>
      <span v-for="(keyword, index) in quickSearchKeywords" :key="index" @click="handleQuickSearch(keyword)">{{ keyword }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchComponent',
  props: {
    inputValue: {
      type: String,
      default: ''
    },
    showQuickSearch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchKeyword: '',
      quickSearchKeywords: ['医用', '感冒', '营养品']
    }
  },
  watch: {
    inputValue(newVal) {
      if (newVal) {
        this.searchKeyword = newVal
        this.$emit('search', newVal)
      }
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.searchKeyword)
    },
    handleQuickSearch(keyword) {
      this.searchKeyword = keyword
      this.$emit('search', keyword)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-section {
  width: 400px;
  // margin: 0 50px;

  .search-container {
    margin-bottom: 10px;

    .search-input {
      ::v-deep .el-input-group__append {
        background: #409eff;
        border-color: #409eff;

        .el-button {
          color: white;
          border: none;

          &:hover,
          &:focus {
            background: #409eff;
            color: white;
          }
        }
      }
    }
  }

  .quick-search {
    font-size: 12px;
    color: #666;
    display: flex;
    justify-content: flex-start;
    margin-left: 5px;
    .quick-search-title {
      margin-right: 10px;
      font-weight: bold;
    }

    span {
      margin-right: 15px;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>
